/* eslint-disable */
import react, { useState } from "react";
import { Sheet_Global } from "./Global/sheet_global";
import { Sheet_Accounting } from "./Accounting/sheet_accounting";
import { moveFileToFolder } from "../Google_drive_OAuth2.0/Move_Folder";
import { Sheet_Accounting_RFC } from "./AccountigWithRFC/sheet_accountingRFC";
import { Sheet_Accounting_withoutRFC } from "./AccountingWithoutRFC/sheet_accountingwithoutRFC";
import { deleteSpaces } from "./CalculateFunctions/CalculateFunctions";

export function Create_spreadsheet() {
  const clientId =
    "863239600242-en0ikm4jerho84a3bi8q7p0qlvv8kjg3.apps.googleusercontent.com";
  const SCOPES = "https://www.googleapis.com/auth/spreadsheets";
  const folderId = "1JWhBEfGBho_joT96mE-LqGiefHn-6DT8";
  const [loading, setLoading] = useState(false);
  const [urlDoc, setUrlDoc] = useState("");

  function TitleSheet() {
    return deleteSpaces(
      "ESTADODECUENTAGLOBAL-" + new Date().toISOString().substring(0, 19)
    );
  }

  function Create_spreadsheet_function(arre_travels, dateRange) {
    const google = window.google;
    google.accounts.oauth2
      .initTokenClient({
        client_id: clientId,
        scope: SCOPES,
        callback: (tokenResponse) => {
          if (tokenResponse && tokenResponse.access_token) {
            setLoading(true);
            const params = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenResponse.access_token}`,
              },
              body: JSON.stringify({
                properties: {
                  title: TitleSheet(),
                  locale: "es_ES",
                },
                sheets: [
                  Sheet_Global(arre_travels, dateRange),
                  Sheet_Accounting(arre_travels, dateRange),
                  Sheet_Accounting_RFC(arre_travels, dateRange),
                  Sheet_Accounting_withoutRFC(arre_travels, dateRange),
                ],
              }),
            };
            fetch("https://sheets.googleapis.com/v4/spreadsheets", params)
              .then((response) => response.json())
              .then(async (data) => {
                const fileId = data;
                console.log(
                  "🚀 ~ file: Create_spreadsheet.js:49 ~ .then ~ fileId:",
                  fileId
                );

                if (fileId?.spreadsheetId) {
                  /*        const moveFiletoFolder = await moveFileToFolder(
                    fileId?.spreadsheetId,
                    folderId,
                    tokenResponse.access_token
                  );

                  if (moveFiletoFolder?.data) { */
                  setUrlDoc(fileId?.spreadsheetUrl);
                  setLoading(false);
                  /*      } else {
                    setUrlDoc("Error");
                    setLoading(false);
                  } */
                } else {
                  setUrlDoc("Error");
                  setLoading(false);
                }
              })
              .catch((error) => {
                setUrlDoc("Error");
                setLoading(false);
                console.error("Error al crear el archivo:", error);
              });
          } else {
            setLoading(false);
          }
        },
      })
      .requestAccessToken();
  }

  return {
    Create_spreadsheet_function,
    loading,
    setUrlDoc,
    urlDoc,
  };
}
